<template>
  <v-btn :color="color" @click="toggleSidebar" flat>
    <v-icon>emoji_events</v-icon>
    <span class="ml-2">Ranking</span>
  </v-btn>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapMutations, mapState } = createNamespacedHelpers("classifier");

export default {
  computed: {
    ...mapState(["showClassRankingSidebar"]),
    color() {
      return this.showClassRankingSidebar ? "blue" : "black";
    },
  },
  methods: {
    ...mapMutations(["setShowClassRankingSidebar"]),
    toggleSidebar() {
      this.setShowClassRankingSidebar(!this.showClassRankingSidebar);
    },
  },
};
</script>